export default "__VITE_ASSET__DrVp2YlO__"